import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, toRefs, watch } from 'vue';
  import { getItemLocalUrl, getItemUrl } from '@/utils/mediaAsset';
  import { logger } from '@/utils/screenEventsLogger';

  
  import { defineComponent } from 'vue';

  const __default__ = defineComponent({
    name: 'AudioSlide',
  });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean, default: false },
    restartSignal: { default: null },
    itemUrl: null,
    itemId: null,
    itemType: null,
    volume: null,
    imageMode: { default: 'cover' },
    mute: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { show: boolean, restartSignal: string | null, itemUrl: string, itemId: string, itemType: string, volume: number, imageMode: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down', mute?: boolean }

  
  const { show, restartSignal, imageMode, itemUrl, itemId, itemType, volume, mute } = toRefs(props);

  const audioRef = ref<HTMLAudioElement | null>(null);

  const audioUrl = computed(() => getItemLocalUrl(itemUrl.value, itemId.value));
  const defaultAudioUrl = computed(() => getItemUrl(itemUrl.value));

  const isWeb = computed(() => {
    return window.isWeb as boolean;
  });

  watch([show, restartSignal], ([newShow, newRestartSignal], [_oldShow, oldRestartSignal]) => {
    if (audioRef.value === null) return;

    if (newShow && newRestartSignal !== oldRestartSignal && newRestartSignal !== null) {
      resetAudio(false);
    }
  });

  watch(show, (newShow, oldShow) => {
    if (audioRef.value === null) return;

    // handle visible to hidden
    if (oldShow === true && newShow === false) {
      resetAudio();
    }
  });

  onMounted(() => {
    if (show.value) {
      playAudio();
    }
  });

  function resetAudio(pause = true) {
    if (audioRef.value === null) return;

    audioRef.value.pause();
    audioRef.value.currentTime = 0;

    if (!pause) {
      playAudio();
    }
  }

  function playAudio() {
    if (audioRef.value === null) return;

    audioRef.value.volume = volume.value;
    audioRef.value.muted = mute.value;
    audioRef.value.currentTime = 0;

    const playPromise = audioRef.value.play();

    // browsers released before 2019 may not return a value
    if (playPromise !== undefined) {
      playPromise.then((_) => {}).catch((_error) => {});
    }
  }

  function handleAudioError() {
    logger.addLog(`Failed to load: ${audioUrl.value}`);
  }

  function handleDefaultAudioError() {
    logger.addLog(`Failed to load default: ${defaultAudioUrl.value}`);
  }

return { __sfc: true,props, show, restartSignal, imageMode, itemUrl, itemId, itemType, volume, mute, audioRef, audioUrl, defaultAudioUrl, isWeb, resetAudio, playAudio, handleAudioError, handleDefaultAudioError }
}

})